/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const CheckInType = {
  CheckIn: "CHECK_IN",
  CheckOut: "CHECK_OUT",
} as const;

export type CheckInType = (typeof CheckInType)[keyof typeof CheckInType];

export type CheckInTypeEnumType = typeof CheckInType;
export type CheckInTypeOptional = CheckInType;
export type CheckInTypeTrackedI = CheckInType;
export type CheckInTypeTracked = CheckInType;
export type CheckInTypeMetaI = EnumMetaType<CheckInTypeEnumType, CheckInType>;
export const CheckInTypeMeta = typeMetaEnum<CheckInTypeEnumType, CheckInType>(
  "CheckInType",
  CheckInType,
);
export function transformDatesCheckInType(model: CheckInType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
